<div class="row margin-bottm" *ngIf="customFilter">
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.scheme">
		<div class="col-sm-12">
			<label for="Batch Type">Scheme/Program/Model</label>
		</div>
		<select class="form-control notranslate" [(ngModel)]="modelObj.scheme" name="scheme" (change)="getSchemeType()">
			<option value=null selected disabled>Select Scheme</option>
			<option *ngFor="let type of schemeType" [ngValue]="type.model">{{type.type}}</option>
		</select>
	</div>
	<!-- <div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.pmkvyType">
		<div class="col-sm-12">
			<label for="Batch Type">Sub PMKVY Type</label>
		</div>
		<select [compareWith]="showSelected" class="form-control" [(ngModel)]="modelObj.pmkvyType" name="pmkvyType" [disabled]="disablePmkvyType">
			<option value="0" selected disabled>Select Sub PMKVY Type</option>
			<option *ngFor="let type of pmkvyType" [ngValue]="type.value">{{type.value}}</option>
		</select>
	</div> -->
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.sector">
		<div class="col-sm-12">
			<label for="Sector">Sector</label>
		</div>
		<select class="form-control notranslate" [(ngModel)]="modelObj.sector" name="sector"
			(change)="getJobRoles('show')">
			<option value=null selected disabled>Select Sector</option>
			<option *ngFor="let sectors of sector" [ngValue]="sectors.sectorID">{{sectors.nameOfSector}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.batchType">
		<div class="col-sm-12">
			<label for="Batch Type">Batch Type</label>
		</div>
		<select class="form-control notranslate" [(ngModel)]="modelObj.batchType" name="batchType">
			<option value="" selected disabled>Select Batch Type</option>
			<option *ngFor="let type of batchType" [ngValue]="type">{{type}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.userType">
		<div class="col-sm-12">
			<label for="User Type">User Type</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.userType"
			name="userType">
			<option value=null selected disabled>Select User Type</option>
			<option *ngFor="let type of userType" [ngValue]="type.userValue">{{type.userName}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.typeOfCertification">
		<div class="col-sm-12">
			<label for="User Type">Certificate Type</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.typeOfCertification"
			name="certificateType">
			<option value="" selected disabled>Select Certificate Type</option>
			<option *ngFor="let type of typeOfCertification" [ngValue]="type.value">{{type.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.originationCategory">
		<div class="col-sm-12">
			<label for="Trainer Type">Origination Category</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.originationCategory"
			name="originationCategory" (change)="selectedCountry()">
			<option value="" selected disabled>Select Origination Category</option>
			<option *ngFor="let category of originationcategories" [ngValue]="category.value">{{category.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.country">
		<div class="col-sm-12">
			<label for="country">Country</label>
		</div>
		<select [compareWith]="showCountry" [disabled]='isDisable' class="form-control notranslate"
			[(ngModel)]="modelObj.country" name="country">
			<option value=null selected disabled>Select Country</option>
			<option *ngFor="let country of countries" [ngValue]="country">{{country.country}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.jobRoles">
		<div class="col-sm-12">
			<label for="Job Role">Job Role</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.jobRole"
			name="jobRole" [disabled]="disableJobRoles">
			<option value="" selected disabled>Select JobRole</option>
			<option *ngFor="let jobRole of jobRoles" [ngValue]="jobRole.qpCode">{{jobRole?.jobRole}}
				({{jobRole?.qpCode}}) - v{{jobRole?.version}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.reqType">
		<div class="col-sm-12">
			<label for="Request Type">Request Type</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.reqType"
			name="RequestType">
			<option value=null selected disabled>Select Request Type</option>
			<option *ngFor="let req of reqType" [ngValue]="req?.value">{{req?.value}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.centre">
		<div class="col-sm-12">
			<label for="ToT/ToA Centre">Training Centre</label>
		</div>
		<input class="form-control m-input notranslate" type="text" placeholder="Search by Training Centre Name"
			id="Search" name="centre" [(ngModel)]="modelObj.centre">
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.state">
		<div class="col-sm-12">
			<label for="State">State</label>
		</div>
		<select class="form-control notranslate" [disabled]="stateDisbale" [(ngModel)]="modelObj.state" name="state"
			(change)="getDistricts()">
			<option value=null selected disabled>Select State</option>
			<option *ngFor="let state of states" [ngValue]="state.code">{{state.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.district">
		<div class="col-sm-12">
			<label for="District">District</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.district"
			name="district">
			<option value=null selected disabled>Select District</option>
			<option *ngFor="let dist of districts" [ngValue]="dist.code">{{dist.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.batchStatus">
		<div class="col-sm-12">
			<label for="Batch Status">Batch Status</label>
		</div>
		<select class="form-control notranslate" [(ngModel)]="modelObj.batchStatus" name="batchStatus"
			(change)="getSelectedValue()">
			<option value=null selected disabled>Select Status</option>
			<option *ngFor="let status of batchStatus" [ngValue]="status.id">
				{{status.value==='Accepted' ? "Accepted / Action Pending" : status.value }}
			</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.aaStatus">
		<div class="col-sm-12">
			<label for="Batch Status">Status</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.aaStatus"
			name="aaStatus">
			<option value="" selected disabled>Select Status</option>
			<option *ngFor="let status of aaStatuses" [ngValue]="status.value">{{status.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.myLinkStatus">
		<div class="col-sm-12">
			<label for="Batch Status">Status</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.myLinkStatus"
			name="myLinkStatus">
			<option value="" selected disabled>Select Status</option>
			<option *ngFor="let status of myLinkStatuses" [ngValue]="status.value">{{status.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.allLinkStatus">
		<div class="col-sm-12">
			<label for="Batch Status">Status</label>
		</div>
		<select [compareWith]="showSelected" class="form-control notranslate" [(ngModel)]="modelObj.allLinkStatus"
			name="allLinkStatus">
			<option value="" selected disabled>Select Status</option>
			<option *ngFor="let status of allLinkStatuses" [ngValue]="status.value">{{status.name}}</option>
		</select>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.startDt">
		<div class="col-sm-12">
			<label for="Keyword Search">Batch Start Date</label>
		</div>
		<input class="notranslate form-control m-input" placeholder="All" type="text" name="startDatae"
			[(ngModel)]="startDt" id="fullDate" #startDate>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.endDt">
		<div class="col-sm-12">
			<label for="Keyword Search">Batch End Date</label>
		</div>
		<input class="notranslate form-control m-input" placeholder="All" type="text" id="fullDate1" [(ngModel)]="endDt"
			#endDate>
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.keyword">
		<div class="col-sm-12">
			<label for="Keyword Search" *ngIf="filterLabel;else otherLabel">Assessment Agency Name/(AAID)</label>
			<ng-template #otherLabel>
				Batch ID
			</ng-template>
		</div>
		<span *ngIf="filterLabel;else input">
			<input class="notranslate form-control m-input" type="text"
				placeholder="Search by Assessment Agency Name/(AAID)" id="Search" name="KeywordSearch"
				[(ngModel)]="modelObj.keyword">
		</span>
		<ng-template #input>
			<input class="notranslate form-control m-input" type="text" placeholder="Search by Batch ID" id="Search"
				name="KeywordSearch" [(ngModel)]="modelObj.keyword">
		</ng-template>

	</div>

	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.newKeywordSearch">
		<div class="col-sm-12">
			<label for="Keyword Search" *ngIf="filterLabel;else otherLabel">Assessment Agency Name/(AAID)</label>
			<ng-template #otherLabel>
				Batch ID
			</ng-template>
		</div>
		<span *ngIf="filterLabel;else input">
			<input class="notranslate form-control m-input" type="text"
				placeholder="Search by Assessment Agency Name/(AAID)" id="Search" name="KeywordSearch"
				[(ngModel)]="modelObj.newKeywordSearch">
		</span>
		<ng-template #input>
			<input (input)="isTyping($event.target.value)" class="notranslate form-control m-input" type="text"
				placeholder="Search by Batch ID" id="Search" name="newKeywordSearch"
				[(ngModel)]="modelObj.newKeywordSearch">
		</ng-template>
	</div>

	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.newBatchType">
		<div class="col-sm-12">
			<label for="Batch Type">Batch Type&nbsp;<span *ngIf="isBatchIdInput" style="color:red;">*</span></label>
			<!-- <label for="Batch Type">Batch Type</label> -->
		</div>
		<select (click)="isBatchTypeSelected()" [compareWith]="showSelected" class="form-control notranslate"
			[(ngModel)]="modelObj.newBatchType" name="newBatchType">
			<option value="" selected disabled>Select Batch Type</option>
			<option *ngFor="let type of batchType" [ngValue]="type">{{type}}</option>
		</select>
	</div>

	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.regStatus">
		<div class="col-sm-12">
			<label for="Batch Type">Registration Status&nbsp;</label>
		</div>
		<select class="form-control notranslate" [(ngModel)]="modelObj.regStatus" name="regStatus">
			<option value="" selected disabled>Select Registration Status</option>
			<option [ngValue]="'registrationCompleted'">{{"Completed"}}</option>
			<option [ngValue]="'registrationInComplete'">{{"Incomplete"}}</option>
		</select>
	</div>



	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.applicantId">
		<div class="col-sm-12">
			<label for="Applicant Search by Id">Search by Applicant Id</label>
		</div>
		<input class="notranslate form-control m-input" type="text" placeholder="Search by Applicant ID"
			id="applicantId" name="applicantId" [(ngModel)]="modelObj.applicantId">
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.proctorId">
		<div class="col-sm-12">
			<label for="Proctor Search by Id">Proctor ID</label>
		</div>
		<input class="notranslate form-control m-input" type="text" placeholder="Search by Proctor Id" id="proctorId"
			name="proctorId" [(ngModel)]="modelObj.proctorId">
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.phone">
		<div class="col-sm-12">
			<label for="Proctor Search by Id">Phone</label>
		</div>
		<input class="notranslate form-control m-input" type="text" placeholder="Phone No" id="phone" name="phone"
			[(ngModel)]="modelObj.phone">
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.batchId">
		<div class="col-sm-12">
			<label for="Search by Batch Id">Search by Batch Id</label>
		</div>
		<input class="notranslate form-control m-input" type="number" placeholder="Search by Batch ID" id="batchId"
			name="batchId" [(ngModel)]="modelObj.batchId">
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.applicantName">
		<div class="col-sm-12">
			<label for="Applicant Search by Name">Search by Applicant Name</label>
		</div>
		<input class="notranslate form-control m-input" type="text" placeholder="Search by Applicant Name"
			id="applicantName" name="applicantName" [(ngModel)]="modelObj.applicantName">
	</div>
	<div class="col-sm-3 padding-right margin-top" *ngIf="customFilter.tcName">
		<div class="col-sm-12">
			<label for="TC Search by Name">Search by TC Name</label>
		</div>
		<input class="notranslate form-control m-input" type="text" placeholder="Search by TC Name" id="tcName"
			name="tcName" [(ngModel)]="modelObj.tcName">
	</div>
	<div class="col-sm-3 padding-right margin-top">
		<div class="col-sm-12">
			<label class="color-trans" for="Keyword Search">Actions</label>
		</div>
		<button [disabled]="isBatchIdInput" *ngIf="customFilter.newKeywordSearch" type="button"
			class="btn btn-primary" (click)="applyFilters();">
			Apply
		</button>
		<button *ngIf="!customFilter.newKeywordSearch" type="button" class="btn btn-primary"
			(click)="applyFilters();">
			Apply
		</button>
		<button type="button" class="btn btn-secondary color-info ml-2" (click)="reset('show')">
			Reset
		</button>
	</div>
</div>